var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tooltip',{attrs:{"content":_vm.contributionLevel.name}},[_c('div',{staticClass:"contribution-level-icon",class:_vm.contributionLevel.iconClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }